<template>
  <div>
    <div
      class="flex items-center bg-action- pb-1 text-center font-bold text-sm"
    >
      <div class="w-1/3">{{ i18n.cost_amount }}</div>
      <div class="w-1/3">
        {{ strikethrough ? i18n.render_amount : i18n.bonus }}
      </div>
      <div class="w-1/3 rounded py-2 text-base text-white bg-secondary">
        {{ promotion.i18n.table_title }}
      </div>
    </div>
    <router-link
      v-for="(line, index) in improvedBonuses"
      :key="line.cost_amount_html"
      class="group cursor-pointer flex py-1 text-center hover:bg-select"
      :class="index % 2 ? 'bg-white' : 'bg-full-white'"
      :to="{ name: 'invoice.new', query: { credits: line.credit } }"
    >
      <div class="w-1/3 self-center" v-html="line.cost_amount_html"></div>
      <div
        class="w-1/3 text-gray-700"
        v-if="strikethrough && line.improved != line.credit"
      >
        <span
          class="diag-through border-gray-700"
          :class="{
            'diag-through border-gray-700': line.improved != line.render,
          }"
          v-html="line.render_amount_html"
        ></span>
      </div>
      <div
        class="w-1/3 text-center flex justify-center items-center rounded-l"
        v-if="!strikethrough && line.improved != line.credit"
      >
        <div
          class="text-black p-1 w-20 rounded text-lg whitespace-no-wrap italic"
        >
          +{{ Math.round(line.percentBonus) }}<small class="align-top">%</small>
        </div>
      </div>
      <div class="w-1/3 text-center flex justify-center items-center">
        <div
          class="p-1 w-24"
          :class="{
            'bg-promo-bg rounded font-bold text-lg whitespace-no-wrap bg-promo-bg- text-promo-fg':
              line.improved != line.credit,
          }"
        >
          {{ line.improved.toLocaleString(locale) }}
          <span class="ranch-credit ml-1">€</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["bonuses", "i18n", "promotion"],
  computed: {
    strikethrough() {
      return true;
    },
    locale() {
      return this.$route.params.locale || "en";
    },
    improvedBonuses() {
      return this.bonuses.map((b) => {
        b.improved = this.improvedRenderAmount(b);
        b.percentBonus = (100 * (b.improved - b.cost)) / b.cost;
        return b;
      });
    },
  },
  methods: {
    improvedRenderAmount({ cost, credit }) {
      if (this.promotion.type === "percentPerCost") {
        return this.continousPercentBonus(cost, credit);
      }
      return this.discreteBonus(cost, credit);
    },
    discreteBonus(cost, render) {
      const bonus = this.promotion.bonuses[cost] || 0;
      return render + bonus;
    },
    continousPercentBonus(cost, render) {
      const bonus = this.findPercentBonus(cost);
      return Math.round(render * (100 + bonus)) / 100;
    },
    findPercentBonus(cost) {
      const costs = Object.keys(this.promotion.bonuses).reverse();
      const i = costs.find((c) => c <= cost);
      if (!i) {
        return 0;
      }
      return this.promotion.bonuses[i];
    },
  },
};
</script>

<style>
.diag-through {
  position: relative;
}
.diag-through:before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  right: 0;
  border-top: 1px solid #000;
  border-color: inherit;

  -webkit-transform: rotate(-7deg);
  -moz-transform: rotate(-7deg);
  -ms-transform: rotate(-7deg);
  -o-transform: rotate(-7deg);
  transform: rotate(-7deg);
}
</style>
